import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { AxiosResponse } from "axios";
import { useFormik } from 'formik';
import moment from "moment";
import * as Yup from 'yup';

import { ModelOfRole, ModelOfPeople, ModelOfPeopleForm } from 'src/database/index';

import { dateToString } from "src/utils/dateToString";
import { useAuth } from "src/contexts/auth";
import api from 'src/services/api';

interface PersonCpfProps {
  ID?: string;
  NOME: string;
  DATANASCIMENTO: string;
  ORGAOUNIDADE: string;
}

export const useFormCreateUnityPeoples = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [roles, setRoles] = useState<ModelOfRole[]>([]);
  const [loadingPersonCpf, setLoadingPersonCpf] = useState(false);
  const [foundPersonCpf, setFoundPersonCpf] = useState(false);
  const [personCpf, setPersonCpf] = useState<PersonCpfProps[]>([{ NOME: '', DATANASCIMENTO: '', ID: '', ORGAOUNIDADE: '' }]);
  const [peopleResponse, setPeopleResponse] = useState<AxiosResponse | null>(null);
  const [peopleEditedResponse, setPeopleEditedResponse] = useState<AxiosResponse | null>(null);

  const { userAgencyId } = useAuth();
  const history = useHistory();

  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    CARGO: Yup.string().required('* Campo obrigatório'),
    NOME: Yup.string().required('* Campo obrigatório'),
    DATANASCIMENTO: Yup.string().required('* Campo obrigatório'),
    CPF: Yup.string().required('* Campo obrigatório'),
    ORGAOUNIDADE: Yup.string().required('* Campo obrigatório')
  });

  const getRoles = async () => {
    try {
      const response = await api.get('functions');
      setRoles(response.data);
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getRoles();
  }, []);

  const saveUnityPeople = async (UnityPeople: ModelOfPeopleForm) => {
    setLoading(true);

    const newUnityPeople: ModelOfPeople = {
      ...UnityPeople,
      ORGAO: userAgencyId,
      DATANASCIMENTO: moment(UnityPeople.DATANASCIMENTO, "DD/MM/YYYY").toDate().toLocaleDateString('en', { year: "numeric", month: "2-digit", day: "2-digit" }),
    }

    if (!!peopleResponse) {
      api.post(`people/${peopleResponse.data.ID}/${peopleResponse.data.ID_ORGAOUNIDADEPESSOA}`, newUnityPeople)
        .then((response) => {
          formik.resetForm();
          setPeopleResponse(response);
          setPeopleEditedResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'A pessoa foi editada com sucesso!', life: 5000 });
        }).catch((err) => {
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        });
    } else {
      if (personCpf.length) {
        api.post(`people/${personCpf[0].ID}`, newUnityPeople)
          .then((response) => {
            if (window.location.href === '/unityPeopleForm') history.push('/listUnityPeoples')
            setPeopleResponse(response);
            setPeopleEditedResponse(null);
            setLoading(false);
            toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Pessoa cadastrada com sucesso!', life: 5000 });
          }).catch((err) => {
            console.log(err);
            setLoading(false);
            toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
          });
      } else {
        api.post('people', newUnityPeople)
          .then((response) => {
            if (window.location.href === '/unityPeopleForm') history.push('/listUnityPeoples')
            setPeopleResponse(response);
            setPeopleEditedResponse(null);
            setLoading(false);
            toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Pessoa cadastrada com sucesso!', life: 5000 });
          }).catch((err) => {
            console.log(err);
            setLoading(false);
            toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
          });
      }
    }
  }

  const formik = useFormik<ModelOfPeopleForm>({
    initialValues: {
      ORGAO: '',
      ORGAOUNIDADE: '',
      CARGO: '',
      NOME: '',
      DATANASCIMENTO: '',
      CPF: '',
    },
    onSubmit: async values => await saveUnityPeople(values),
    validationSchema
  });

  const searchPersonCpf = async (cpf: string) => {
    setLoadingPersonCpf(true);
    const response = await api.post('people/get-person', { CPF: cpf });

    setPersonCpf(response.data);
    setFoundPersonCpf(!!response.data[0]);
    setLoadingPersonCpf(false);
  };

  useEffect(() => {
    if (foundPersonCpf) {
      formik.setFieldValue('NOME', personCpf[0].NOME);
      formik.setFieldValue('DATANASCIMENTO', dateToString(personCpf[0].DATANASCIMENTO, 'br'));
      formik.setFieldValue('ORGAOUNIDADE', personCpf[0].ORGAOUNIDADE)
    }
  }, [foundPersonCpf]);

  return {
    getUnityPeopleFormController: {
      formik,
      loading,
      roles,
      loadingPersonCpf,
      foundPersonCpf,
      personCpf,
      toast,
      peopleResponse,
      peopleEditedResponse
    },
    handleUnityPeopleFormController: {
      searchPersonCpf,
      setFoundPersonCpf,
      setPeopleResponse
    }
  };
};
